import React from 'react';
import Slider from "react-slick";
import { Card, Button, Container, Row, Col } from "react-bootstrap";
import _ from 'lodash';
import WhiteImage from '../../../_Views/Styles/image/white.png';
import { userApi } from "../../../api"; /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-29>*/

export default props => {

     /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-29>*/
     async function viewMoreClick(bmo,files,filelocation){
        let page="resources";
        let filename = files['filename'];
        let bmoname = bmo;
        let obj={};
        obj['userid']=localStorage['currentuserid'];
        obj['message']= "D_" + bmoname + " - " + filename;
        await userApi.setUserActivitylog(obj); 
    }
    /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-29>*/

    const items = props.data
    console.log(`carousel data:`, items)
    const cards = items.map(item => {
        const imgUrl = (item.cover_photo && item.cover_photo.sizes['resources-cover-photo']) ? item.cover_photo.sizes['resources-cover-photo'] : 'https://place-hold.it/500x650';
        return (
            <Card key={`id${item.ID}`} className="post-card">
                <Card.Img variant="top" src={imgUrl} />
                <Card.Body>
                    <Card.Title>{item.title}</Card.Title>
                    <Card.Text className="text-muted">{item.type}</Card.Text>
                    {(item.file !== false) && (
                          /*<a target="_blank" href={item.file.url} className={"btn btn-primary"}>View File</a>*/ /*Comments: User Activity Log Code Changes, Modified By: <Asar>, Date Modified: <2020-01-29>*/
                          <a onClick={()=>viewMoreClick(props.bmoname,item.file,item.file.url)} href={item.file.url} target="_blank" className={"btn btn-primary"} >View File</a> /*Comments: User Activity Log Code Changes, Modified By: <Asar>, Date Modified: <2020-01-29>*/
                    )}                    
                </Card.Body>
            </Card>
        )
    })

    const sliderSettings = {
        dots: true,
        infinite: true,
        gap: 20,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5
    }

    return (
        <Container className="text-center my-5">
            <h3 className="mb-4">{props.title?props.title:`Other Resources From ${props.bmoname ? props.bmoname : " "}`} </h3>
            {
                cards.length == 0 &&
                <div className="no-posts">
                    <h5>No Posts Available</h5>
                </div>
            }
            {
                cards.length > 4 &&
                <Slider className="post-card-slider" {...sliderSettings}>
                    {cards}
                </Slider>
            }
            {
                cards.length <= 4 &&
                <Row className="post-card-slider">
                    {cards.map(card => <Col sm="3">{card}</Col>)}
                </Row>
            }
        </Container>
    )
}